import { Quote } from '../../models/quote';

/**
 * Display reference for a quotation — same convention as sales (`#saleNumber`).
 * Quote numbers are 1-based; 0 / missing fall back to a short document id.
 */
export function getQuoteReference(
  quote: Pick<Quote, 'id' | 'quoteNumber'> | null | undefined
): string {
  if (!quote) return '#';
  if (quote.quoteNumber != null && Number(quote.quoteNumber) >= 1) {
    return `#${Number(quote.quoteNumber)}`;
  }
  if (quote.id) return `${quote.id.substring(0, 8)}`;
  return '#';
}
